
export default {
  props: {
    product: {
      type: Object,
      default: null
    },
    sku: {
      type: String,
      default: null
    },
    variant: {
      type: Object,
      default: null
    }
  },
  vessel: {
    title: {
      all: {
        color: 'black',
        fontSize: '2xl'
      },
      lg: {
        fontSize: '3xl'
      }
    },
    description: {
      textColor: 'grey-darkest',
      lineHeight: 'lg'
    },
    availability: {
      fontSize: 'sm',
      color: 'grey-darkest'
    }
  },
  computed: {
    availability() {
      return this.variant
        ? this.variant.availability
        : this.product.availability
    }
  }
}
